// DIRECTUS
export const DIRECTUS_SERVER = "https://www.meine-uniklinik.de";
export const DIRECTUS_PROJECT = "_";

// ANIMATIONS
export const AOS_ANIMATION = "fade-up";
export const AOS_DURATION = 600;
export const AOS_DELAY = 300;
export const AOS_OFFSET =
  window.innerHeight * 0.15 > 150 ? 150 : window.innerHeight * 0.15;

// STAGE
export const STAGE_INTERVAL = 6000;

// ANALYTICS
export const GA_MEASUREMENT_ID = "UA-49053441-6";
